import i18next from 'i18next';
import common from '../../common';
import Text from '../../ui/Text';

export default class ScenarioDifficultySelect extends PIXI.Container {
	constructor(scenarioId) {
		super();

		this.signals = {
			select: new P3.utils.MiniSignal(),
		};

		this.init(scenarioId);
	}

	init(scenarioId) {
		const scenarios = common.config.scenarios;

		const data = [
			{ scenario: scenarios[scenarioId - 1], difficulty: 'easy', icons: 1, data: P3.assets.json(`scenario${scenarioId}`).difficulty.easy },
			{ scenario: scenarios[scenarioId - 1], difficulty: 'medium', icons: 2, data: P3.assets.json(`scenario${scenarioId}`).difficulty.medium },
			{ scenario: scenarios[scenarioId - 1], difficulty: 'hard', icons: 3, data: P3.assets.json(`scenario${scenarioId}`).difficulty.hard },
		];

		for (let i = 0; i < data.length; i++) {
			const panel = this.createPanel(data[i], i);

			panel.position.set((panel.width * (data.length - 1) * -0.5) + (i * panel.width), 0);
			this.addChild(panel);
		}
	}

	createPanel(data, index) {
		const container = new PIXI.Container();

		const panel = new PIXI.NineSlicePlane(P3.assets.texture(`panel_difficulty_${data.difficulty}_9slice`), 40, 180, 40, 40);

		panel.height = 550;
		panel.width = 340;
		panel.position.set(panel.width * -0.5, panel.height * -0.5);
		container.addChild(panel);

		for (let i = 0; i < 3; i++) {
			const icon = new PIXI.Sprite(P3.assets.texture(`icon_${data.scenario}`));

			icon.anchor.set(0.5);
			icon.scale.set(0.5);
			icon.position.set((icon.width * 2 * -0.5) + (i * icon.width), -panel.height * 0.5 + 120);
			container.addChild(icon);

			if (i >= data.icons) {
				icon.tint = 0x0;
				icon.alpha = 0.5;
			}
		}

		const difficultylabel = new Text(`gui.general.difficulties.${data.difficulty}`, { font: '32px', fontWeight: 'bold', align: 'center', tint: 0xFFFFFF });

		difficultylabel.anchor.set(0, 0.5);
		difficultylabel.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 50);
		container.addChild(difficultylabel);

		const budgetlabel = new Text('gui.budgetpanel.budget', { font: '32px', fontWeight: 'bold', align: 'center', tint: 0x0 });

		budgetlabel.anchor.set(0, 0.5);
		budgetlabel.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 205);
		container.addChild(budgetlabel);

		const budgetvalue = new Text(`$${data.data.budget.total}`, { font: '32px', align: 'center', tint: 0x0 });

		budgetvalue.anchor.set(0, 0.5);
		budgetvalue.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 235);
		container.addChild(budgetvalue);

		let splitter = new PIXI.Graphics();

		splitter.beginFill(0xc7c7c7);
		splitter.drawRect(0, 0, panel.width - 100, 1);
		splitter.endFill();
		splitter.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 255);
		container.addChild(splitter);

		const timelabel = new Text('gui.selectscenario.time', { font: '32px', fontWeight: 'bold', align: 'center', tint: 0x0 });

		timelabel.anchor.set(0, 0.5);
		timelabel.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 280);
		container.addChild(timelabel);

		const timeIcon = new PIXI.Sprite(P3.assets.texture('icon_clock'));

		timeIcon.anchor.set(0, 0.5);
		timeIcon.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 310);
		container.addChild(timeIcon);

		const text = i18next.t('gui.selectscenario.minsremaining', { TIME: data.data.time / 60 });
		const timevalue = new Text(text, { font: '32px', align: 'center', tint: 0x0 });

		timevalue.anchor.set(0, 0.5);
		timevalue.position.set(-panel.width * 0.5 + 80, -panel.height * 0.5 + 310);
		container.addChild(timevalue);

		splitter = new PIXI.Graphics();
		splitter.beginFill(0xc7c7c7);
		splitter.drawRect(0, 0, panel.width - 100, 1);
		splitter.endFill();
		splitter.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 330);
		container.addChild(splitter);

		const populationlabel = new Text('gui.populationpanel.population', { font: '32px', fontWeight: 'bold', align: 'center', tint: 0x0 });

		populationlabel.anchor.set(0, 0.5);
		populationlabel.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 355);
		container.addChild(populationlabel);

		const personIcon = new PIXI.Sprite(P3.assets.texture('icon_person'));

		personIcon.anchor.set(0, 0.5);
		personIcon.tint = 0x0;
		personIcon.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 385);
		container.addChild(personIcon);

		const populationvalue = new Text(`${data.data.population.total}`, { font: '32px', align: 'center', tint: 0x0 });

		populationvalue.anchor.set(0, 0.5);
		populationvalue.position.set(-panel.width * 0.5 + 70, -panel.height * 0.5 + 385);
		container.addChild(populationvalue);

		splitter = new PIXI.Graphics();
		splitter.beginFill(0xc7c7c7);
		splitter.drawRect(0, 0, panel.width - 100, 1);
		splitter.endFill();
		splitter.position.set(-panel.width * 0.5 + 50, -panel.height * 0.5 + 405);
		container.addChild(splitter);

		const playLabel = new Text('gui.selectscenario.play', { font: '32px', align: 'center', tint: 0xFFFFFF });
		const playButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: playLabel.width + 105, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: playLabel.width + 105, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});

		playButton.position.set(0, panel.height * 0.5 - 90);
		playButton.signals.click.add(() => {
			this.signals.select.dispatch(data.difficulty);
		}, this);
		container.addChild(playButton);

		playLabel.anchor.set(0, 0.5);
		playLabel.position.set(playButton.width * -0.5 + 35, 0);
		playButton.animation.addChild(playLabel);

		const playIcon = new PIXI.Sprite(P3.assets.texture('icon_play'));

		playIcon.anchor.set(0.5);
		playIcon.position.set(playButton.width * 0.5 - 35, 0);
		playButton.animation.addChild(playIcon);

		playButton.accessibleTitle = i18next.t('accessibility.button.playDifficulty', { DIFFICULTY: i18next.t(`gui.general.difficulties.${data.difficulty}`) });
		playButton.tabIndex = index + 1;

		return container;
	}

	destroy() {
		super.destroy();
	}
}
